import { createBaseApi, getAuthHeaders } from '../utils/baseApi';

const apiVersion = 'v1';

const { getJson, postJson, deleteJson, putJson } = createBaseApi(`/api/${apiVersion}`, { headers: getAuthHeaders });

export const updateAttachmentUrl = (attachmentId, data = {}) => putJson(`/attachments/${attachmentId}`, data);

export const updateAttachmentStatus = (attachmentId, status) => putJson(`/attachments/${attachmentId}/status`, { status });
